import { useDispatch, useSelector } from 'react-redux';
import { Lead } from '../models/lead.model';
import { RootState } from '../store';
import { CALC_LINK, EVENT_GET_LEAD, SEND_PARAMS } from '../constants';
import { Service } from '../models/service.model';
import { useCallback, useMemo } from 'react';
import { Result } from '../reducers/quiz/interfaces/result.interface';
import { showError, togglePreloader } from '../reducers/main/main.actions';
import { apiService } from '../services/api.service';
import { addLead } from '../reducers/client/client.actions';
import { getPhone } from '../reducers/quiz/quiz.actions';
import { emitEvent } from '../event-emitter';
import { logService } from '../services/log.service';
import { FormType } from '../enums/form-type.enum';
import { useFingerprint } from './use-fingerprint.hook';
import services from '../utils/services';

const addCalcLink = (service: Service, clientId: string, amount: number) => {
	return `${CALC_LINK}/?service=${service}&amount=${amount}&clientId=${clientId}`;
}

function defineOpenPage(initialPageIndex: number, numOfServices: number = 1) {
	if (initialPageIndex == 0) return "start_page";
	else {
		if (numOfServices > 1) return "selection";
		if (numOfServices == 1) return "1_quesiton";
	}

	if (initialPageIndex == 99) return "sign_up";

	return "other";
}

function formatQuizResults(arr: Result[]) {
	var result = arr.map(item => {
		const formatedItem: Partial<Result> = { question: item.question, answer: item.answer };
		return Object.values(formatedItem).join(': ').replace('?', '');
	});
	return result.join(',\r\n');
}

export interface ICreateLeadParams {
	phone: string;
	name?: string;
	additionalAgreement?: boolean;
}

export const useCreateLead = (form_type: FormType) => {
	const dispatch = useDispatch();
	const { passed, currentService, results } = useSelector((state: RootState) => state.quiz);
	const { initialPageIndex } = useSelector((state: RootState) => state.main);
	const { clientId, queryParams, customLeadParams, lead, location, serviceList, application, whatsApp, specialOffers } = useSelector((state: RootState) => state.client || {});
	const stack = useSelector((state: RootState) => state.history.stack);
	const calculator = useSelector((state: RootState) => state.quiz.calculator);
	const amount = currentService == 'braces' ? calculator?.jaws : calculator?.teeth;
	const calcLink = (passed && clientId && calculator) ? addCalcLink(currentService as Service, clientId, amount) : undefined;
	const service = serviceList?.length == 1 ? currentService : (passed ? currentService : undefined);
	const bonuses = specialOffers?.enable ? (specialOffers?.list || []) : [];
	const { fingerprint } = useFingerprint();

	let openPage = useMemo(() => defineOpenPage(initialPageIndex, customLeadParams?.serviceNum), [initialPageIndex, customLeadParams]);

	const createLead = useCallback(async ({ phone, name, additionalAgreement }: ICreateLeadParams): Promise<Lead> => {

		if (lead?._id) return new Promise(resolve => resolve(lead));
		emitEvent(SEND_PARAMS, { form_type });
		let receivedLead: Partial<Lead> = {};

		let data: any = {
			phone: phone,
			clientId: clientId as string,
			...queryParams,
			...customLeadParams,
			calcLink,
			location,
			service: service as Service,
			service_ru: services[service as Service]?.name || "Без указания услуги",
			quizResults: passed ? formatQuizResults(results) : 'Без прохождения теста',
			form_type: form_type,
			stepsNum: stack.length,
			openPage,
			wa_enable: whatsApp?.enable,
			wa_onFirstScreen: whatsApp?.onFirstScreen,
			wa_inDoctorBlock: whatsApp?.inDoctorBlock,
			wa_start_page_text: whatsApp?.start_page_text,
			wa_form_page_text: whatsApp?.form_page_text,
			bonuses: bonuses.map(bonus => bonus.label).join(", "),
			fingerprint,
		}

		if (name) data = { ...data, name };
		if (application?.additionalAgreement?.name && additionalAgreement != undefined) data[application?.additionalAgreement?.name] = additionalAgreement;

		dispatch(togglePreloader(true, 'transparent'));

		try {
			receivedLead = await apiService.addLead(data);
			console.log(receivedLead);
			dispatch(addLead(receivedLead as Lead));
			dispatch(getPhone(true));

			dispatch(togglePreloader(false));


			return receivedLead as Lead;
		} catch (error) {
			console.error(error);
			logService.error(error as any, receivedLead, 'get-lead');
			dispatch(togglePreloader(false, "transparent"));

			if ((error as any)?.message?.includes("spam")) {
				emitEvent(SEND_PARAMS, { spam: 1 });
			} else {
				emitEvent(SEND_PARAMS, { error: 1 });
			}
			return {} as any;
		} finally {
			logService.message('Get lead', receivedLead, 'get-lead');
			emitEvent(EVENT_GET_LEAD, { ...receivedLead, quizIsPassed: passed });
		}

	}, [bonuses, clientId, queryParams, customLeadParams, calcLink, location, service, passed, lead, stack, openPage, whatsApp, form_type, fingerprint]);

	return createLead;
}